<template>
  <app-layout :heading="$t('heading')">
    <archives-overview />
  </app-layout>
</template>
<script>
import ArchivesOverview from '@/components/routes/archives/ArchivesOverview'

export default {
  name: 'ArchivesOverviewView',
  components: { ArchivesOverview },
  i18n: {
    messages: {
      en: {
        heading: 'Archive overview'
      },
      de: {
        heading: 'Stundenzettel Archiv'
      },
      ru: {
        heading: 'Обзор архивов'
      },
      tr: {
        heading: 'Arşiv'
      }
    }
  }
}
</script>
